import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({ selector: '[appPostalCodeDirective]' })
/**
  * @function PostalCodeDirective formats the canadian zip code
  **/
export class PostalCodeDirective {
  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let trimmed = input.value.replace(/\s+/g, '');
    if (trimmed.length > 6) {
      trimmed = trimmed.substr(0, 6);
    }
    const numbers = [];
    for (let i = 0; i < trimmed.length; i += 3) {
      numbers.push(trimmed.substr(i, 3));
    }
    input.value = numbers.join(' ');
  }
}
